"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_select_1 = __importStar(require("react-select"));

var prop_types_1 = __importDefault(require("prop-types"));

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

function SzSelect(_a) {
  var id = _a.id,
      options = _a.options,
      value = _a.value,
      className = _a.className,
      autoFocus = _a.autoFocus,
      isDisabled = _a.isDisabled,
      isMulti = _a.isMulti,
      isSearchable = _a.isSearchable,
      name = _a.name,
      onChange = _a.onChange,
      placeholder = _a.placeholder,
      isClearable = _a.isClearable,
      defaultOptions = _a.defaultOptions;

  var DropdownIndicator = function DropdownIndicator(props) {
    return react_1.default.createElement(react_select_1.components.DropdownIndicator, __assign({}, props), react_1.default.createElement(SzIcon_1.default, {
      variant: "bold",
      icon: "arrow-down-1",
      className: "text-danger"
    }));
  };

  var customStyles = {
    control: function control(styles, state) {
      return __assign({}, styles, {
        backgroundColor: 'white',
        borderColor: state.isFocused ? '#030f40' : '#E7E8EE',
        borderRadius: 0,
        minHeight: '58px',
        boxShadow: 'none',
        '&:hover': {
          borderColor: '#030f40'
        }
      });
    },
    option: function option(provided, state) {
      return __assign({}, provided, {
        fontWeight: state.isSelected ? 'bold' : 'normal',
        padding: 10,
        backgroundColor: state.isSelected && '#F4F8FF',
        color: state.isSelected && '#030f40',
        '&:hover': {
          backgroundColor: '#FCFCFC'
        }
      });
    },
    dropdownIndicator: function dropdownIndicator(styles) {
      return __assign({}, styles, {
        color: '#030f40'
      });
    },
    indicatorSeparator: function indicatorSeparator(styles) {
      return __assign({}, styles, {
        backgroundColor: 'transparent'
      });
    },
    input: function input(styles) {
      return __assign({}, styles);
    },
    placeholder: function placeholder(styles) {
      return __assign({}, styles);
    },
    singleValue: function singleValue(styles, _a) {
      var data = _a.data;
      return __assign({}, styles);
    }
  };
  return react_1.default.createElement(react_select_1.default, {
    id: id,
    value: value,
    onChange: onChange,
    options: options,
    isSearchable: isSearchable,
    isDisabled: isDisabled,
    isMulti: isMulti,
    name: name,
    placeholder: placeholder,
    isClearable: isClearable,
    className: className,
    styles: customStyles,
    components: DropdownIndicator,
    defaultOptions: defaultOptions
  });
}

exports.default = SzSelect;
SzSelect.propTypes = {
  options: prop_types_1.default.array,
  value: prop_types_1.default.oneOf([Object, Array, null, undefined]),
  className: prop_types_1.default.string,
  autoFocus: prop_types_1.default.bool,
  isDisabled: prop_types_1.default.bool,
  isMulti: prop_types_1.default.bool,
  isSearchable: prop_types_1.default.bool,
  name: prop_types_1.default.string,
  onChange: prop_types_1.default.func,
  placeholder: prop_types_1.default.node
};